export const handleInterceptorRequestBounderyAPI = (configRequest) => {
  configRequest.headers = {
    ...configRequest.headers,
    responseType: "arraybuffer",
    decompress: true,
  };

  return configRequest;
};
